var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04736 17.4736C13.6792 17.4736 17.5142 13.6304 17.5142 9.00684C17.5142 4.375 13.6709 0.540039 9.03906 0.540039C4.41553 0.540039 0.580566 4.375 0.580566 9.00684C0.580566 13.6304 4.42383 17.4736 9.04736 17.4736ZM9.04736 16.0625C5.12939 16.0625 2 12.9248 2 9.00684C2 5.08887 5.12109 1.95117 9.03906 1.95117C12.957 1.95117 16.0947 5.08887 16.103 9.00684C16.1113 12.9248 12.9653 16.0625 9.04736 16.0625ZM8.13428 12.9497C8.4082 12.9497 8.64062 12.8169 8.80664 12.5596L12.6001 6.59131C12.6914 6.42529 12.7993 6.24268 12.7993 6.06006C12.7993 5.68652 12.4673 5.4458 12.1187 5.4458C11.9111 5.4458 11.7036 5.57861 11.5459 5.81934L8.10107 11.3477L6.46582 9.23096C6.2666 8.96533 6.08398 8.89893 5.85156 8.89893C5.49463 8.89893 5.2124 9.18945 5.2124 9.55469C5.2124 9.7373 5.28711 9.91162 5.40332 10.0693L7.42871 12.5596C7.63623 12.8335 7.86035 12.9497 8.13428 12.9497Z",
    fill: "#2EE54C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircle);
export default __webpack_public_path__ + "static/media/success-circle.83cbcbd2c30a038f48c54e7212503430.svg";
export { ForwardRef as ReactComponent };